var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjectExecution(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 916 504",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient1",
    x1: 0.012,
    y1: 0.021,
    x2: 1,
    y2: 0.964,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient1-2",
    x1: 0.5,
    x2: -2.084,
    y2: 1.515,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bd1822"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1300fd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient1-4",
    x2: -0.587,
    y2: 1.513,
    xlinkHref: "#linear-gradient1-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26069",
    "data-name": "Group 26069",
    transform: "translate(-277 -1514)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26046",
    "data-name": "Group 26046",
    transform: "translate(161.713 1223.787)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_15882",
    "data-name": "Rectangle 15882",
    transform: "translate(115.288 305.213)",
    stroke: "rgba(255,255,255,0.62)",
    strokeWidth: 1,
    fill: "url(#linear-gradient1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 260,
    height: 200,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 259,
    height: 199,
    rx: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26032",
    "data-name": "Group 26032",
    transform: "translate(170.072 290.213)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_16151",
    "data-name": "Rectangle 16151",
    d: "M20.215,0H59.891a0,0,0,0,1,0,0V128.228a0,0,0,0,1,0,0H20.215A20.215,20.215,0,0,1,0,108.013v-87.8A20.215,20.215,0,0,1,20.215,0Z",
    transform: "translate(11.987 59.891) rotate(-90)",
    fill: "url(#linear-gradient1-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143573",
    "data-name": "Path 143573",
    d: "M198.2,237.5,186.216,252.9H198.2Z",
    transform: "translate(-186.216 -237.504)",
    fill: "#040a2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143574",
    "data-name": "Path 143574",
    d: "M397.651,237.5,409.638,252.9H397.651Z",
    transform: "translate(-257.436 -237.504)",
    fill: "#040a2b"
  })), /*#__PURE__*/React.createElement("text", {
    id: "STEP_01",
    "data-name": "STEP  01",
    transform: "translate(202.8 329.925)",
    fill: "#fff",
    fontSize: 20,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "STEP  "), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontSize: 32
  }, "01")), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_16152",
    "data-name": "Rectangle 16152",
    d: "M8.5,0H50.171a8.5,8.5,0,0,1,8.5,8.5v0a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0v0A8.5,8.5,0,0,1,8.5,0Z",
    transform: "translate(219.285 496.201)",
    fill: "#4f08af"
  }), /*#__PURE__*/React.createElement("text", {
    id: "At_any_point_of_time_if_the_client_ask_for_pricing_or_updated_feasibility_to_the_PM_the_PM_loops_back_the_sales_team_to_the_email_chain_.",
    "data-name": "At any point of time if the client ask for pricing or updated feasibility to the PM, the PM loops back the sales team to the email chain\\u200B.",
    transform: "translate(127.287 367.213)",
    fill: "#191817",
    fontSize: 12,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500,
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 7,
    y: 13
  }, "At any point of time if the client ask "), /*#__PURE__*/React.createElement("tspan", {
    x: 9,
    y: 35
  }, "for pricing or updated feasibility to "), /*#__PURE__*/React.createElement("tspan", {
    x: 7,
    y: 57
  }, "the PM, the PM loops back the sales "), /*#__PURE__*/React.createElement("tspan", {
    x: 41,
    y: 79
  }, "team to the email chain\u200B."))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26047",
    "data-name": "Group 26047",
    transform: "translate(489.713 1223.787)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_16204",
    "data-name": "Rectangle 16204",
    transform: "translate(115.288 305.213)",
    stroke: "rgba(255,255,255,0.62)",
    strokeWidth: 1,
    fill: "url(#linear-gradient1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 260,
    height: 200,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 259,
    height: 199,
    rx: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26032-2",
    "data-name": "Group 26032",
    transform: "translate(170.072 290.213)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_16151-2",
    "data-name": "Rectangle 16151",
    d: "M20.215,0H59.891a0,0,0,0,1,0,0V128.228a0,0,0,0,1,0,0H20.215A20.215,20.215,0,0,1,0,108.013v-87.8A20.215,20.215,0,0,1,20.215,0Z",
    transform: "translate(11.987 59.891) rotate(-90)",
    fill: "url(#linear-gradient1-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143573-2",
    "data-name": "Path 143573",
    d: "M198.2,237.5,186.216,252.9H198.2Z",
    transform: "translate(-186.216 -237.504)",
    fill: "#040a2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143574-2",
    "data-name": "Path 143574",
    d: "M397.651,237.5,409.638,252.9H397.651Z",
    transform: "translate(-257.436 -237.504)",
    fill: "#040a2b"
  })), /*#__PURE__*/React.createElement("text", {
    id: "STEP_02",
    "data-name": "STEP  02",
    transform: "translate(202.8 329.925)",
    fill: "#fff",
    fontSize: 20,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "STEP  "), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontSize: 32
  }, "02")), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_16152-2",
    "data-name": "Rectangle 16152",
    d: "M8.5,0H50.171a8.5,8.5,0,0,1,8.5,8.5v0a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0v0A8.5,8.5,0,0,1,8.5,0Z",
    transform: "translate(219.285 496.201)",
    fill: "#4f08af"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Discuss_pricing_with_Amit_and_for_feasibility_write_back_to_presales_team_in_the_old_email_chain_.",
    "data-name": "Discuss pricing with Amit and for feasibility write back to presales team in the old email chain\\u200B.",
    transform: "translate(127.287 367.213)",
    fill: "#191817",
    fontSize: 12,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500,
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 15,
    y: 13
  }, "Discuss pricing with Amit and for "), /*#__PURE__*/React.createElement("tspan", {
    x: 16,
    y: 35
  }, "feasibility write back to presales "), /*#__PURE__*/React.createElement("tspan", {
    x: 30,
    y: 57
  }, "team in the old email chain\u200B."))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26048",
    "data-name": "Group 26048",
    transform: "translate(817.713 1223.787)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_16205",
    "data-name": "Rectangle 16205",
    transform: "translate(115.288 305.213)",
    stroke: "rgba(255,255,255,0.62)",
    strokeWidth: 1,
    fill: "url(#linear-gradient1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 260,
    height: 200,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 259,
    height: 199,
    rx: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26032-3",
    "data-name": "Group 26032",
    transform: "translate(170.072 290.213)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_16151-3",
    "data-name": "Rectangle 16151",
    d: "M20.215,0H59.891a0,0,0,0,1,0,0V128.228a0,0,0,0,1,0,0H20.215A20.215,20.215,0,0,1,0,108.013v-87.8A20.215,20.215,0,0,1,20.215,0Z",
    transform: "translate(11.987 59.891) rotate(-90)",
    fill: "url(#linear-gradient1-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143573-3",
    "data-name": "Path 143573",
    d: "M198.2,237.5,186.216,252.9H198.2Z",
    transform: "translate(-186.216 -237.504)",
    fill: "#040a2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143574-3",
    "data-name": "Path 143574",
    d: "M397.651,237.5,409.638,252.9H397.651Z",
    transform: "translate(-257.436 -237.504)",
    fill: "#040a2b"
  })), /*#__PURE__*/React.createElement("text", {
    id: "STEP_03",
    "data-name": "STEP  03",
    transform: "translate(202.8 329.925)",
    fill: "#fff",
    fontSize: 20,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "STEP  "), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontSize: 32
  }, "03")), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_16152-3",
    "data-name": "Rectangle 16152",
    d: "M8.5,0H50.171a8.5,8.5,0,0,1,8.5,8.5v0a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0v0A8.5,8.5,0,0,1,8.5,0Z",
    transform: "translate(219.285 496.201)",
    fill: "#4f08af"
  }), /*#__PURE__*/React.createElement("text", {
    id: "If_in_case_the_observed_LOI_is_way_more_than_what_was_mentioned_in_the_initial_specs_the_PM_loops_back_Sales_team_for_CPI_revisions._",
    "data-name": "If in case the observed LOI is way more than what was mentioned in the initial specs, the PM loops back Sales team for CPI revisions.\\u200B",
    transform: "translate(127.287 367.213)",
    fill: "#191817",
    fontSize: 12,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500,
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 15,
    y: 13
  }, "If in case the observed LOI is way "), /*#__PURE__*/React.createElement("tspan", {
    x: 10,
    y: 35
  }, "more than what was mentioned in "), /*#__PURE__*/React.createElement("tspan", {
    x: 8,
    y: 57
  }, "the initial specs, the PM loops back "), /*#__PURE__*/React.createElement("tspan", {
    x: 29,
    y: 79
  }, "Sales team for CPI revisions.\u200B"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26049",
    "data-name": "Group 26049",
    transform: "translate(161.713 1512.787)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_16206",
    "data-name": "Rectangle 16206",
    transform: "translate(115.288 305.213)",
    stroke: "rgba(255,255,255,0.62)",
    strokeWidth: 1,
    fill: "url(#linear-gradient1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 260,
    height: 200,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 259,
    height: 199,
    rx: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26032-4",
    "data-name": "Group 26032",
    transform: "translate(170.072 290.213)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_16151-4",
    "data-name": "Rectangle 16151",
    d: "M20.215,0H59.891a0,0,0,0,1,0,0V128.228a0,0,0,0,1,0,0H20.215A20.215,20.215,0,0,1,0,108.013v-87.8A20.215,20.215,0,0,1,20.215,0Z",
    transform: "translate(11.987 59.891) rotate(-90)",
    fill: "url(#linear-gradient1-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143573-4",
    "data-name": "Path 143573",
    d: "M198.2,237.5,186.216,252.9H198.2Z",
    transform: "translate(-186.216 -237.504)",
    fill: "#040a2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143574-4",
    "data-name": "Path 143574",
    d: "M397.651,237.5,409.638,252.9H397.651Z",
    transform: "translate(-257.436 -237.504)",
    fill: "#040a2b"
  })), /*#__PURE__*/React.createElement("text", {
    id: "STEP_04",
    "data-name": "STEP  04",
    transform: "translate(202.8 329.925)",
    fill: "#fff",
    fontSize: 20,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "STEP  "), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontSize: 32
  }, "04")), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_16152-4",
    "data-name": "Rectangle 16152",
    d: "M8.5,0H50.171a8.5,8.5,0,0,1,8.5,8.5v0a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0v0A8.5,8.5,0,0,1,8.5,0Z",
    transform: "translate(219.285 496.201)",
    fill: "#4f08af"
  }), /*#__PURE__*/React.createElement("text", {
    id: "In_all_these_cases_remove_the_PM_tam_and_reply_back_to_the_client_with_pricing._Once_approved_remove_pricing_details_and_loop_back_the_PM_team.",
    "data-name": "In all these cases, remove the PM tam and reply back to the client with pricing. Once approved, remove pricing details and loop back the PM team.",
    transform: "translate(127.287 367.213)",
    fill: "#191817",
    fontSize: 12,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500,
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 14,
    y: 13
  }, "In all these cases, remove the PM "), /*#__PURE__*/React.createElement("tspan", {
    x: 2,
    y: 35
  }, "tam and reply back to the client with "), /*#__PURE__*/React.createElement("tspan", {
    x: 17,
    y: 57
  }, "pricing. Once approved, remove "), /*#__PURE__*/React.createElement("tspan", {
    x: 3,
    y: 79
  }, "pricing details and loop back the PM "), /*#__PURE__*/React.createElement("tspan", {
    x: 99,
    y: 101
  }, "team."))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26050",
    "data-name": "Group 26050",
    transform: "translate(489.713 1512.787)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_16207",
    "data-name": "Rectangle 16207",
    transform: "translate(115.288 305.213)",
    stroke: "rgba(255,255,255,0.62)",
    strokeWidth: 1,
    fill: "url(#linear-gradient1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 260,
    height: 200,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 259,
    height: 199,
    rx: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26032-5",
    "data-name": "Group 26032",
    transform: "translate(170.072 290.213)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_16151-5",
    "data-name": "Rectangle 16151",
    d: "M20.215,0H59.891a0,0,0,0,1,0,0V128.228a0,0,0,0,1,0,0H20.215A20.215,20.215,0,0,1,0,108.013v-87.8A20.215,20.215,0,0,1,20.215,0Z",
    transform: "translate(11.987 59.891) rotate(-90)",
    fill: "url(#linear-gradient1-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143573-5",
    "data-name": "Path 143573",
    d: "M198.2,237.5,186.216,252.9H198.2Z",
    transform: "translate(-186.216 -237.504)",
    fill: "#040a2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143574-5",
    "data-name": "Path 143574",
    d: "M397.651,237.5,409.638,252.9H397.651Z",
    transform: "translate(-257.436 -237.504)",
    fill: "#040a2b"
  })), /*#__PURE__*/React.createElement("text", {
    id: "STEP_05",
    "data-name": "STEP  05",
    transform: "translate(202.8 329.925)",
    fill: "#fff",
    fontSize: 20,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "STEP  "), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontSize: 32
  }, "05")), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_16152-5",
    "data-name": "Rectangle 16152",
    d: "M8.5,0H50.171a8.5,8.5,0,0,1,8.5,8.5v0a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0v0A8.5,8.5,0,0,1,8.5,0Z",
    transform: "translate(219.285 496.201)",
    fill: "#4f08af"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Post_which_send_another_email_to_finance_jaspercolin.com_stating_the_revisions_.",
    "data-name": "Post which send another email to finance@jaspercolin.com stating the revisions\\u200B.",
    transform: "translate(127.287 367.213)",
    fill: "#191817",
    fontSize: 12,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500,
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 13,
    y: 13
  }, "Post which send another email to "), /*#__PURE__*/React.createElement("tspan", {
    x: 2,
    y: 35
  }, "finance@jaspercolin.com stating the "), /*#__PURE__*/React.createElement("tspan", {
    x: 88,
    y: 57
  }, "revisions\u200B."))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26051",
    "data-name": "Group 26051",
    transform: "translate(817.713 1512.787)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_16208",
    "data-name": "Rectangle 16208",
    transform: "translate(115.288 305.213)",
    stroke: "rgba(255,255,255,0.62)",
    strokeWidth: 1,
    fill: "url(#linear-gradient1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 260,
    height: 200,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 259,
    height: 199,
    rx: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26032-6",
    "data-name": "Group 26032",
    transform: "translate(170.072 290.213)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_16151-6",
    "data-name": "Rectangle 16151",
    d: "M20.215,0H59.891a0,0,0,0,1,0,0V128.228a0,0,0,0,1,0,0H20.215A20.215,20.215,0,0,1,0,108.013v-87.8A20.215,20.215,0,0,1,20.215,0Z",
    transform: "translate(11.987 59.891) rotate(-90)",
    fill: "url(#linear-gradient1-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143573-6",
    "data-name": "Path 143573",
    d: "M198.2,237.5,186.216,252.9H198.2Z",
    transform: "translate(-186.216 -237.504)",
    fill: "#040a2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143574-6",
    "data-name": "Path 143574",
    d: "M397.651,237.5,409.638,252.9H397.651Z",
    transform: "translate(-257.436 -237.504)",
    fill: "#040a2b"
  })), /*#__PURE__*/React.createElement("text", {
    id: "STEP_06",
    "data-name": "STEP  06",
    transform: "translate(202.8 329.925)",
    fill: "#fff",
    fontSize: 20,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "STEP  "), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontSize: 32
  }, "06")), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_16152-6",
    "data-name": "Rectangle 16152",
    d: "M8.5,0H50.171a8.5,8.5,0,0,1,8.5,8.5v0a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0v0A8.5,8.5,0,0,1,8.5,0Z",
    transform: "translate(219.285 496.201)",
    fill: "#4f08af"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Be_in_regular_touch_with_the_client_on_separate_email_chain_and_take_continuous_feedback._",
    "data-name": "Be in regular touch with the client on separate email chain and take continuous feedback.\\u200B",
    transform: "translate(127.287 367.213)",
    fill: "#191817",
    fontSize: 12,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500,
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 3,
    y: 13
  }, "Be in regular touch with the client on "), /*#__PURE__*/React.createElement("tspan", {
    x: 21,
    y: 35
  }, "separate email chain and take "), /*#__PURE__*/React.createElement("tspan", {
    x: 50,
    y: 57
  }, "continuous feedback.\u200B"))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectExecution);
export default __webpack_public_path__ + "static/media/projectExecution.76183544999c2bb52fea0ca87724fc89.svg";
export { ForwardRef as ReactComponent };